import { defineSlotRecipe } from '@chakra-ui/react'

/** Highlight only the recommended plan's table column, in the same tint and accent as its plan card. */
export const paywallComparisonHighlightRecipe = defineSlotRecipe({
  className: 'sco-paywall-comparison-highlight',
  slots: ['header', 'price', 'cell'],
  base: {
    header: {
      bg: 'colorPalette.card/40',
      borderTopColor: 'orange.solid',
      borderTopWidth: '3px',
      color: 'fg',
    },
    price: {
      color: 'fg.muted',
    },
    cell: {
      bg: 'colorPalette.card/20',
    },
  },
  variants: {
    appearance: {
      standard: {},
      quiet: {
        header: {
          bg: 'colorPalette.container/50',
          borderTopWidth: 0,
        },
        cell: {
          bg: 'colorPalette.container/30',
        },
      },
    },
  },
  defaultVariants: {
    appearance: 'standard',
  },
})
